import { render } from "./MainView.vue?vue&type=template&id=c8111716&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=c8111716&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebamoh\\WebstormProjects\\qrscanner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8111716"]])

export default __exports__